/**
 * NotFound Page - 404 error page for unknown routes
 */

import { ContentBlock, Box } from 'braid-design-system';
import type React from 'react';
import { Link } from 'react-router';

import { PageHead } from '../../components/PageHead/PageHead';

import * as styles from './NotFound.css';

export const NotFound: React.FC = () => (
  <ContentBlock width="medium">
    <PageHead
      title="Page Not Found"
      description="The page you are looking for could not be found."
      noIndex
    />
    <Box paddingY="xlarge">
      <div className={styles.container}>
        <h1 className={styles.title}>Page Not Found</h1>
        <p className={styles.message}>
          Oops! It seems this fairy path leads nowhere.
          <br />
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link to="/" className={styles.homeButton}>
          Return Home
        </Link>
      </div>
    </Box>
  </ContentBlock>
);
